import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginService } from '../core/services/login.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../core/services/storage.service';
import { AssessmentService } from '../core/services/assessment.service';
import { CommonService } from '../core/services/common.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  public registrationForm!: FormGroup;
  public registrationErrResp!: string;
  isSubmitted: boolean = false;
  contactguid!: string;
  assessmentList!: any;
  isRegistered: boolean = false;
  passwordMatch = true;
  userDetails: any;
  isEmailDisabled!: boolean;
  ivValue: any;
  modalRef!: BsModalRef;
  allowdKeys = [
    'backspace',
    'delete',
    'arrowleft',
    'arrowright',
    'arrowdown',
    'arrowup',
  ];
  otpDetails: any;
  allowedKeysAlphabet = [8, 9, 37, 38, 39, 40, 46, 189, 190, 222];
  path = '';
  isOtpAuthenticated: boolean = false;
  returnUrl = '';
  isAlreadyRegistered: boolean = false;
  loadOTPComponent: any;
  registerFormLoaded = false;
  isDeactivated = false;

  constructor(private loginService: LoginService, private route: Router, public formBuilder: FormBuilder,
    private storageService: StorageService, private activateRoute: ActivatedRoute, private modalService: BsModalService,
    private assessmentService: AssessmentService, private commonService: CommonService) {
    route.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }
  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('Contactid') && queryParam.hasOwnProperty('Key')) {
        this.contactguid = queryParam.Contactid;
        this.ivValue = queryParam.Key;
        this.fetchNewUserData();
      }
    });

  }

  fetchNewUserData() {
    const rqstBody = { contactguid: this.contactguid, auth: this.ivValue };
    this.assessmentService.getNewUserData(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      // console.log('get user data in user profile: ', decryptedData);
      this.userDetails = JSON.parse(JSON.stringify(decryptedData));
      // console.log('user details in registration: ',this.userDetails);
      this.loadOTPComponent = true;
      this.isAlreadyRegistered = this.userDetails.isAlreadyRegistered;
      if (!this.userDetails?.isActivate) {
        this.isDeactivated = true;
      }
      this.otpDetails = {
        isOtpSent: this.userDetails.isOtpSent,
        otpValue: this.userDetails.otpValue,
        resendotpcount: this.userDetails.resendotpcount,
        wrongotpcount: this.userDetails.wrongotpcount,
        otpSentTime: this.userDetails.otpSentTime ? parseInt(this.userDetails.otpSentTime) : this.userDetails.otpSentTime
      }
      if (this.isDeactivated) {
        this.showDeactivationPopup();
      } else {
        if (this.isAlreadyRegistered) {
          this.openAlreadyRegisteredPopup();
        }
      }
    });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = 'Contact/Assessment Entity has been deactivated.';
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  openAlreadyRegisteredPopup() {
    let message = 'This contact has already completed the registration process.';
    const initialState = {
      message: message,
      redirectTo: 'login',
      cancelButton: false
    };
    this.modalRef = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  afterVerifiedOtpCheck(evt: boolean) {
    this.isOtpAuthenticated = evt;
    if (this.isOtpAuthenticated == true) {
      // this.activateRoute.queryParams.subscribe((queryParam: any)=> {
      //   if(queryParam.hasOwnProperty('Contactid') && queryParam.hasOwnProperty('Key')) {
      //     this.contactguid = queryParam.Contactid;
      //     this.ivValue = queryParam.Key;
      //   }
      // });
      this.registrationForm = this.formBuilder.group({
        firstname: ['', [Validators.required]],
        lastname: ['', [Validators.required]],
        mobile: ['', [Validators.required]],
        countrycode: ['', [Validators.required]],
        email: ['', [Validators.required]],
        emiratesId1: ['', [Validators.required]],
        emiratesId2: ['', [Validators.required]],
        emiratesId3: ['', [Validators.required]],
        emiratesId4: ['', [Validators.required]],
        // password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')]],
        password: ['', [Validators.required, Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#\$%\^\&\*\{\(\)\+\[=._-\`\,\;\?<\}>\/\:\'\"\|])(?!.* )(?!.*\\\\)(?!.*\]).{8,15}$')]],
        confirmPassword: ['', [Validators.required]]
      });
      if (this.userDetails) {
        this.setContactDetails();
      }
      this.registerFormLoaded = true;
    }
  }

  setContactDetails() {
    // const rqstBody = {contactguid : this.contactguid, auth : this.ivValue};
    // this.assessmentService.getNewUserData(rqstBody).subscribe((res) => {
    //   let decryptedData = this.commonService.decryptUsingAES256(res?.data);
    //     console.log('get user data in user profile: ', decryptedData);
    //     this.userDetails = JSON.parse(JSON.stringify(decryptedData));
    //     console.log('user details in registration: ',this.userDetails);
    let emiratesIdArr;
    if (this.userDetails.emiratesId) {
      emiratesIdArr = this.userDetails.emiratesId.split('-');
    }
    this.registrationForm.patchValue({
      email: this.userDetails.email,
      firstname: this.userDetails.firstname,
      lastname: this.userDetails.lastname,
      mobile: this.userDetails.mobilephone,
      countrycode: this.userDetails.countrycode
    });
    if (emiratesIdArr?.length == 4) {
      this.registrationForm.patchValue({
        emiratesId1: emiratesIdArr[0],
        emiratesId2: emiratesIdArr[1],
        emiratesId3: emiratesIdArr[2],
        emiratesId4: emiratesIdArr[3]
      });
    }
    this.isAlreadyRegistered = this.userDetails.isAlreadyRegistered;

    this.registrationForm.controls['email'].disable();
    // this.registrationForm.controls['mobile'].disable();

    if (this.isAlreadyRegistered) {
      this.registrationErrResp = 'This contact has already completed the registration process.';
    }
    //  });
  }

  clearPasswordErr(event: any) {
    this.passwordMatch = true;
    // if (event.key == '\\' || event.which == 220 || event.key == ';' || event.which == 186) {
    //   event.preventDefault();
    //   return;
    // }
  }

  checkNumber(event: any) {
    if (
      !this.allowdKeys.includes(event.key?.toLowerCase()) &&
      isNaN(Number(event.key)) && event.which != 9
    ) {
      event.preventDefault();
      return;
    }
  }

  checkAlphabets(e: any) {
    var regex = new RegExp("^[ A-Za-z]*$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str) || this.allowedKeysAlphabet.includes(e.which) || e.key == "'" || e.key == '-' || e.key == '.') {
      return true;
    }
    e.preventDefault();
    return false;
  }

  onPaste(e: any) {
    e.preventDefault();
    return false;
  }

  registerUser() {
    this.isSubmitted = true;
    this.passwordMatch = this.registrationForm.value.password === this.registrationForm.value.confirmPassword;
    if (this.registrationForm.valid && this.passwordMatch) {
      const registrationData = {
        firstname: this.registrationForm.value.firstname,
        lastname: this.registrationForm.value.lastname,
        mobile: this.registrationForm.value.mobile,
        email: this.userDetails.email,
        countrycode: this.registrationForm.value.countrycode,
        emirateId: `${this.registrationForm.value.emiratesId1}-${this.registrationForm.value.emiratesId2}-${this.registrationForm.value.emiratesId3}-${this.registrationForm.value.emiratesId4}`,
        password: this.registrationForm.value.password,
        assessmentUnit: this.userDetails.assessmentUnit.value,
        contactguid: this.contactguid,
        auth: this.ivValue
      }
      this.loginService.registerUser(registrationData).subscribe((data: any) => {
 //console.log('isRegistered User data: ', data);
        if (data?.error) {
          this.registrationErrResp = data?.error;
        } else {
          let decryptedData = this.commonService.decryptUsingAES256(data?.data);
          if (decryptedData?.isRegistered === true) {
            this.isSubmitted = false;
            this.isRegistered = true;
            this.registrationForm.reset();
            setTimeout(() => {
              this.route.navigate(['login']);
            }, 10000)

          }
        }
      });
    }
  }

}
